import { useContext, useState, useEffect } from "react";
import { Alert, Box, Card, CardContent, Grid, Link, TextField, Typography, InputLabel, MenuItem } from "@mui/material";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useNavigate } from "react-router-dom";
import AppContext from "../contexts/AppContext";
import axios from "axios";
import Config from "../config/Config";
import { configAPIHeaders } from "../services/api";
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
import LoadingButton from "@mui/lab/LoadingButton";
import functionsCoverageArea from "../services/coverageArea.service";
import CityInterface from "../interfaces/CityInterface";
import StateInterface from "../interfaces/StateInterface";


const Register = (props) => {
	const appContext = useContext(AppContext);
	const navigation = useNavigate();
	const notyf = new Notyf();

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [passwordConfirmation, setPasswordConfirmation] = useState("");
	const [companyName, setCompanyName] = useState("");
	const [cnpj, setCnpj] = useState("");
	const [phone, setPhone] = useState("");
	const [neighborhood, setNeighborhood] = useState("");
	const [number, setNumber] = useState("");
	const [cep, setCep] = useState("");
	const [cityCode, setCityCode] = useState("");
	const [cityName, setCityName] = useState("");
	const [street, setStreet] = useState("");
	const [complement, setComplement] = useState("");
	const [stateAcronym, setStateAcronym] = useState("");

	const [selectedState, setSelectedState] = useState<StateInterface>();
	const [selectedCity, setSelectedCity] = useState<CityInterface>();
	const [states, setStates] = useState<StateInterface[]>();
	const [cities, setCities] = useState<CityInterface[]>();

	const [loadingRegister, setLoadingRegister] = useState<boolean>(false);

	const [errorMessage, setErrorMessage] = useState<string>("");

	const handleChangeState = (event: SelectChangeEvent) => {
		const currentState = states?.find((state) => {
			return state._id === event.target.value as string
		});
		setSelectedState(currentState);
		setStateAcronym(currentState?.acronym || "");
	};

	const handleChangeCity = (event: SelectChangeEvent) => {
		const currentCity = cities?.find((city) => {
			return city._id === event.target.value as string
		});
		setSelectedCity(currentCity);
		setCityName(currentCity?.name || "");
		setCityCode(currentCity?.cityCode || "");
	};

	useEffect(() => {
		functionsCoverageArea.getAreaStatesByCountry()
		.then((response) => {
			setStates(response.data.states);
			setSelectedState(response.data.states[0]);
			setStateAcronym(response.data.states[0].acronym || '');
		}).catch((error) => {
			console.log(error);
		});
	}, []);

	useEffect(() => {
		if (selectedState !== undefined){
			functionsCoverageArea.getAreaCitiesByState(selectedState?._id)
			.then((response) => {
				setCities(response.data.cities);
			}).catch((error) => {
				console.log(error);
			})
		}
	}, [selectedState]);

	const register = async () => {
		if (appContext !== null) {
			setLoadingRegister(true);
			try {
				await axios.post(Config.BASE_URL_API_PUBLIC + "/auth/register?publicRegister=true", {
					email: email,
					password: password,
					companyName: companyName,
					phone: phone,
					cnpj: cnpj,
					address: {
						stateAcronym: stateAcronym,
						street: street,
						ibgeCityCode: cityCode,
						cityName: cityName,
						cep: cep,
						number: number,
						neighborhood: neighborhood,
						coordinates: [0, 0]
					},
				})
					.then(async response => {
						await axios.post(Config.BASE_URL_API_PUBLIC + "/auth/login", {
							email: email,
							password: password
						}).then(async responseLogin => {
							if (responseLogin.status === 200) {
								if (responseLogin.data.accessToken !== undefined) {
									configAPIHeaders(appContext, responseLogin.data.accessToken, response.data.id);
									appContext.setTokenValue(responseLogin.data.accessToken);
									appContext.setUserEmailValue(responseLogin.data.email);
									appContext.setUserIDValue(responseLogin.data.id);
									localStorage.setItem("token", responseLogin.data.accessToken);
									localStorage.setItem("email", responseLogin.data.email);
									localStorage.setItem("userID", responseLogin.data.id);
									navigation("/orders");
									notyf.success("Conta criada com sucesso!");
								} else {
									setLoadingRegister(false);
								}
							}
						}).catch((error) => {
							notyf.error('Ocorreu um erro. Tente novamente mais tarde');
							navigation("/login");
						});

					}).catch((error) => {
						console.log("CAIU NESSE CATCH");
						console.log(error);

						// Tratativa do erro
						if (error?.response?.data?.type === "DUPLICATE_EMAIL") {
							setErrorMessage("Este e-mail já está sendo utilizado");
						}

						// Tratativa do erro
						if (error?.response?.data?.type === "INVALID_EMAIL") {
							setErrorMessage("Este e-mail é inválido");
						}

						// Tratativa do erro
						if (error?.response?.data?.type === "INVALID_DOCUMENT") {
							setErrorMessage("CNPJ ou CPF são inválidos");
						}

						notyf.error('Erro ao criar a conta. Revise as informações e tente novamente.');
						setLoadingRegister(false);
					});

			} catch (error) {
				// appContext.setLoadingLoginValue(false);
				// appContext.setTokenValue(null);
				// appContext.setUserEmailValue(null);
				// appContext.setUserIDValue(null);
				notyf.error('Erro ao criar a conta. Revise as informações e tente novamente.');
				setLoadingRegister(false);
			}
		}
	}

	return (
		<>
			<Box>
				<Grid
					container
				>
					<Grid
						item
						xs={12}
						md={12}
						lg={12}
						style={{
							justifyContent: 'center',
							alignContent: 'center',
							backgroundColor: 'white'
						}}
					>
						<Box display={"flex"} justifyContent="center" alignItems={"center"} alignContent={"center"} alignSelf={"center"} minHeight={"95vh"}>
							<Card
								style={{
									margin: "auto",
									minWidth: 300,
									width: "40vw"
								}}
								elevation={0}
							>
								<CardContent>
									<Typography variant={"caption"} component={"p"}>Leve Aí - Parceiros</Typography>
									<Typography variant={"body1"} component={"p"}>Bem vindo(a)!</Typography>
									<Typography variant={"h4"} component={"h4"} style={{ fontWeight: 'bold' }}>Criar uma conta</Typography>

									<Box
										mt={2}
										mb={2}
									>
										{errorMessage !== "" && <Alert severity="error">{errorMessage}</Alert>}
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"E-mail"}
											placeholder={"Digite o seu e-mail"}
											variant={"outlined"}
											type={"email"}
											value={email}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setEmail(event.target.value);
											}}
											fullWidth
											autoComplete="email"
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Senha"}
											placeholder={"Digite a sua senha"}
											variant={"outlined"}
											value={password}
											type={"password"}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setPassword(event.target.value);
											}}
											fullWidth
											autoComplete="new-password"
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Confirmação da Senha"}
											placeholder={"Digite a confirmação da senha"}
											variant={"outlined"}
											value={passwordConfirmation}
											type={"password"}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setPasswordConfirmation(event.target.value);
											}}
											fullWidth
											autoComplete="new-password"
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Empresa"}
											placeholder={"Digite o nome da empresa"}
											variant={"outlined"}
											type={"text"}
											value={companyName}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setCompanyName(event.target.value);
											}}
											fullWidth
											autoComplete="off"
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"CNPJ"}
											placeholder={"Digite o CNPJ da empresa"}
											variant={"outlined"}
											type={"text"}
											value={cnpj}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setCnpj(event.target.value);
											}}
											fullWidth
											autoComplete="off"
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Telefone"}
											placeholder={"Digite o telefone da empresa"}
											variant={"outlined"}
											type={"text"}
											value={phone}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setPhone(event.target.value);
											}}
											fullWidth
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<InputLabel id="demo-simple-select-filled-label">Estado</InputLabel>
										<Select
											labelId="demo-simple-select-filled-label"
											id="demo-simple-select-filled"
											value={selectedState?._id ?? ""}
											onChange={handleChangeState}
											error={selectedState === undefined}
											fullWidth
										>
											{states?.map((state: StateInterface) => (
												<MenuItem key={state._id} value={state._id}>{state.name}</MenuItem>
											))}
										</Select>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<InputLabel id="demo-simple-select-filled-label">Cidade</InputLabel>
										<Select
											labelId="demo-simple-select-filled-label"
											id="demo-simple-select-filled"
											value={selectedCity?._id ?? ""}
											onChange={handleChangeCity}
											error={cityCode === undefined}
											fullWidth
										>
											{cities?.map((city: CityInterface) => (
												<MenuItem key={city._id} value={city._id}>{city.name}</MenuItem>
											))}
										</Select>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Cep"}
											placeholder={"Digite o cep da empresa"}
											variant={"outlined"}
											type={"text"}
											value={cep}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setCep(event.target.value);
											}}
											fullWidth
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Rua"}
											placeholder={"Digite o rua da empresa"}
											variant={"outlined"}
											type={"text"}
											value={street}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setStreet(event.target.value);
											}}
											fullWidth
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Complemento"}
											placeholder={"Digite o complemento da rua da empresa"}
											variant={"outlined"}
											type={"text"}
											value={complement}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setComplement(event.target.value);
											}}
											fullWidth
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Número"}
											placeholder={"Digite o número da empresa"}
											variant={"outlined"}
											type={"text"}
											value={number}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setNumber(event.target.value);
											}}
											fullWidth
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Bairro"}
											placeholder={"Digite o bairro da empresa"}
											variant={"outlined"}
											type={"text"}
											value={neighborhood}
											onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
												setNeighborhood(event.target.value);
											}}
											fullWidth
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<LoadingButton
											onClick={() => {
												setLoadingRegister(true);
												setTimeout(() => {
													register()
												}, 1000);
											}}
											variant={"contained"}
											fullWidth
											disabled={loadingRegister || password === "" || email === "" || passwordConfirmation === "" || companyName === "" || cnpj === "" || phone === ""}
											loading={loadingRegister}
											color={"primary"}
										>
											Criar conta
										</LoadingButton>
									</Box>

									<Box
										textAlign={"center"}
										pt={3}
										pb={3}
									>
										<Link
											component="button"
											variant="body2"
											onClick={() => {
												navigation("/login");
											}}
										>
											Já tem uma conta? Entrar
										</Link>
									</Box>
								</CardContent>
							</Card>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};

export default Register;